export class WhatsAppLogAddModel {
	constructor() {
		this.whatsAppFileLogs = [];
	}

	appointmentId: number;
	whatsAppFrom: string;
	whatsAppTo: string;
	whatsAppMessage: string;
	createdBy: string;
	whatsAppFileLogs: WhatsAppFileLogModel[];
}

export class WhatsAppFileLogModel {
	whatsAppFileName: string
	whatsAppFileUrl: string
}